import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { ClaimListResponse } from '../types'

const fetchSarabanList = async (params: {
  searchDetails: string
  page: number
  limit: number
  sortBy: string
  filter: string
}) => {
  const searchDetails = params.searchDetails ? `search=${params.searchDetails}&` : ''
  const sortBy = params.sortBy ? `&sortBy=${params.sortBy}` : ''
  const filter = params.filter ? `&${params.filter}` : ''

  const response = await httpClientPrivate.get<ClaimListResponse>(
    `${config.restUrl}/v1/backoffice/e-claim/saraban?${searchDetails}page=${params.page}&limit=${params.limit}${sortBy}${filter}`,
  )

  return response.data
}
const useSarabanList = (params: {
  searchDetails: string
  page: number
  limit: number
  sortBy: string
  filter: string
  enabled: boolean
}) => {
  const queryKey = ['useSarabanList', params]
  const queryFn = async () => fetchSarabanList(params)
  const queryResult = useQuery({ queryKey, queryFn, enabled: params.enabled })

  return { ...queryResult }
}
export { fetchSarabanList, useSarabanList }
